import { getEmployeeType } from "../../../../../actions/Utilities/EmployeeType";
import { useQuery } from "react-query";

export default function useEmployeeType() {
  //Fetching EmployeeType Details
  const {data, isFetching} = useQuery("GetEmployeeType", getEmployeeType, {
    refetchOnWindowFocus: false,
  });

  return {data, isFetching};
}
